"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonLoading = void 0;
var React = require("react");
var ButtonLoading_style_1 = require("./ButtonLoading.style");
var Button_1 = require("../Button/Button");
var Loader_1 = require("../Loader/Loader");
exports.ButtonLoading = function (props) {
    var loaderColor = props.loaderColor;
    return (React.createElement(Button_1.default, __assign({}, props, { disabled: props.disabled != undefined && props.disabled ? props.disabled : props.loading }),
        props.disabled != undefined && props.disabled
            ? null
            : props.loading && (React.createElement(ButtonLoading_style_1.default.Container, null,
                React.createElement(Loader_1.default, { type: "circle", color: loaderColor }))),
        props.children ? props.children : 'Button'));
};
exports.default = exports.ButtonLoading;
//# sourceMappingURL=ButtonLoading.js.map